<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>Blacklist</h2>
        <ol class="breadcrumb">
          <li>
            This list shows all people punished for no-show in any past registered activities.
          </li>
        </ol>
      </div>
      <div
           id="add_blacklist"
           class="col-xs-3 mobile-hide">
        <button
                class="btn btn-md btn-primary"
                data-toggle="modal"
                data-target="#blacklistModal">
          <strong>Add Person</strong>
        </button>
      </div>
      <div
           id="add_blacklist-mobile"
           class="col-xs-3 mobile-show">
        <!-- <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#blacklistModal">
          <strong>Add Person</strong>
        </button> -->
        <!--div class="modal inmodal fade" id="blacklistModal-mobile" tabindex="-1" role="dialog" aria-labelledby="blacklistLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Person to Blacklist</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form role="form">
                  <div class="form-group">
                    <label>Student/Work ID</label>
                    <input type="text" placeholder="Enter student/work id" class="form-control" v-model="addBlacklistSchoolId">
                  </div>
                  <div class="form-group">
                    <label>Start Date</label>
                    <div class="input-group date">
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                      <datepicker :bootstrap-styling="true" v-model="addBlacklistDate">
                      </datepicker>
                    </div>
                    <p style="color:#aaaaaa;">Please click and select the date</p>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-md btn-primary" data-dismiss="modal" v-on:click="addUserToList()">Confirm
                </button>
              </div>
            </div>
          </div>
        </div-->
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Search Signed User</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="ibox-content">
                <div class="row m-b-xs">
                  <div class="col-md-7">
                    <div class="form-inline">
                      <div class="form-group m-r-md">
                        <input
                               v-model="searchInputName"
                               type="text"
                               placeholder="Name"
                               class="form-control">
                      </div>
                      <div class="form-group">
                        <input
                               v-model="searchInputId"
                               type="text"
                               placeholder="School/Work Id"
                               class="form-control">
                      </div>
                      <div class="checkbox m-l-md m-r-md">
                        <input
                               id="searchIsAdmin"
                               v-model="searchIsAdmin"
                               type="checkbox">
                        <label for="searchIsAdmin">
                          Admin
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <button
                            class="btn btn-primary"
                            style="width:100%"
                            @click="searchSignedUser()">Search</button>
                  </div>
                  <div class="col-md-2">
                    <button
                            class="btn btn-primary"
                            style="width:100%"
                            @click="searchReset()">Reset</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <p>You don’t need to fill in all boxes.</p>
                  </div>
                </div>
                <div
                     v-if="searchResultShow"
                     class="row animated fadeInDown">
                  <div class="col-ld-12">
                    <vuetable
                              ref="vuetable"
                              :fields="fields"
                              :data="searchResult"
                              :css="tablecss"
                              :api-mode="false"
                              @vuetable:cell-clicked="onCellClicked" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Blacklist</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-primary btn-xs"
                        @click="downloadBlacklist">Download as Excel</button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                           class="m-r-sm"
                           style="max-width:20%;">Sort By</label>
                    <select
                            v-model="sortType"
                            class="form-control"
                            style="max-width:80%;display: inline-flex;">
                      <option value="0">Name A-Z</option>
                      <option value="1">Name Z-A</option>
                      <option value="2">ID 0-9</option>
                      <option value="3">ID 9-0</option>
                      <option value="4">No 0-9</option>
                      <option value="5">Time Remain Positive</option>
                      <option value="6">Time Remain Negative</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                           class="m-r-sm"
                           style="max-width:50%;">Item per page</label>
                    <select
                            v-model="perPageInput"
                            class="form-control"
                            style="max-width:50%;display: inline-flex;">
                      <option value="1">1</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <vuetable-pagination
                                       ref="pagination"
                                       :css="paginationcss"
                                       @vuetable-pagination:change-page="onChangePage" />
                </div>
              </div>
              <vuetable
                        ref="vuetable"
                        :fields="blacklistFields"
                        :data="formatBlacklistArray"
                        :css="tablecss"
                        :api-mode="false"
                        pagination-path="pagination"
                        @vuetable:cell-clicked="onBlacklistCellClicked" />
              <div class="vuetable-pagination">
                <vuetable-pagination-info ref="paginationInfo" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Passed Blacklist</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-6">
                  <!--<div class="form-group">
                    <label class="m-r-sm" style="max-width:20%;">Sort By</label>
                    <select class="form-control" style="max-width:80%;display: inline-flex;" v-model="sortType">
                      <option value="0">Name A-Z</option>
                      <option value="1">Name Z-A</option>
                      <option value="2">ID 0-9</option>
                      <option value="3">ID 9-0</option>
                      <option value="4">No 0-9</option>
                      <option value="5">Time Remain Positive</option>
                      <option value="6">Time Remain Negative</option>
                    </select>
                  </div>-->
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                           class="m-r-sm"
                           style="max-width:50%;">Item per page</label>
                    <select
                            v-model="passedBlacklistPerPageInput"
                            class="form-control"
                            style="max-width:50%;display: inline-flex;">
                      <option value="1">1</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <vuetable-pagination
                                       ref="passedBlacklistPagination"
                                       :css="paginationcss"
                                       @vuetable-pagination:change-page="onPassedBlacklistChangePage" />
                </div>
              </div>
              <vuetable
                        ref="vuetable"
                        :fields="passedBlacklistFields"
                        :data="formatPassedBlacklistArray"
                        :css="tablecss"
                        :api-mode="false"
                        pagination-path="pagination" />
              <div class="vuetable-pagination">
                <vuetable-pagination-info ref="passedBlacklistPaginationInfo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
         id="blacklistModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="blacklistLabel"
         aria-hidden="true">
      <div
           class="modal-dialog text-left"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Person to Blacklist</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form role="form">
              <div class="form-group">
                <label>Name</label>
                <input
                       v-model="addBlacklistName"
                       type="text"
                       placeholder="Enter student name (in Chinese)"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Student/Work ID</label>
                <input
                       v-model="addBlacklistSchoolId"
                       type="text"
                       placeholder="Enter student/work id"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Start Date</label>
                <div class="input-group date">
                  <span class="input-group-addon">
                    <i class="fa fa-calendar" />
                  </span>
                  <datepicker
                              :bootstrap-styling="true"
                              v-model="addBlacklistDate" />
                </div>
                <p style="color:#aaaaaa;">Please click and select the date</p>
              </div>
              <div class="form-group">
                <label for="new-reason">Reason</label>
                <textarea
                          id="new-reason"
                          v-model="addBlacklistReason"
                          name="reason"
                          class="form-control"
                          rows="5" /><br>
              </div>
            </form>
            <div
              v-show="errorShow"
              class="toast-top-right"
              style="margin: 0 0 2%;"
            >
              <div
                class="toast toast-error"
                style="opacity: 0.69075;"
              >
                <div
                  class="toast-message"
                  style="padding: 1%; color: white; font-size: 1.5rem;"
                >
                  This user cannot be added: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Cancel</button>
            <button
              id="blacklistBtn"
              type="submit"
              class="btn btn-md btn-primary"
              @click="addUserToList()"
            >Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="delBlacklistModal"
      class="modal inmodal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="delBlacklistModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog text-left"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delete Person in Blacklist</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this user from blacklist?</p>
            <p>Name: {{ delBlacklistName }}</p>
            <p>School/Work ID: {{ delBlacklistSchoolId }}</p>
            <div
              v-show="errorShow"
              class="toast-top-right"
              style="margin: 0 0 2%;"
            >
              <div
                class="toast toast-error"
                style="opacity: 0.69075;"
              >
                <div
                  class="toast-message"
                  style="padding: 1%; color: white; font-size: 1.5rem;"
                >
                  This user cannot be deleted: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Cancel</button>
            <button
              id="delBlacklistBtn"
              type="submit"
              class="btn btn-md btn-primary"
              @click="delUserBlacklistInfo()"
            >Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import "@/assets/inspinia/font-awesome/css/font-awesome.css";
import Datepicker from "vuejs-datepicker";
import XLSX from "xlsx";
import Vuetable from "vuetable-2/src/components/Vuetable";
import Vue from "vue";
import VueEvents from "vue-events";
import VuetablePagination from "./VuetablePaginationDropdownCustom.vue";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
Vue.use(VueEvents);

export default {
  name: "Blacklist",
  components: {
    Datepicker,
    Vuetable,
    vueevents: VueEvents,
    VuetablePagination,
    VuetablePaginationInfo
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      addBlacklistId: "",
      addBlacklistDate: Date(),
      addBlacklistSchoolId: "",
      addBlacklistName: "",
      addBlacklistReason: "",
      blacklistArray: [],
      passedBlacklistArray: [],
      formatBlacklistArray: [],
      formatPassedBlacklistArray: [],
      userArray: [],
      blacklistHTML: "",
      postUserBlacklistStatusURL: "",
      usersInfo: [],
      fields: [
        {
          name: "No",
          title: "No."
        },
        {
          name: "Name",
          title: "Name"
        },
        {
          name: "ID",
          title: "ID"
        },
        {
          name: "User Type"
        },
        "Add To Blacklist"
      ],
      blacklistFields: [
        {
          name: "No",
          title: "No."
        },
        {
          name: "Name",
          title: "Name"
        },
        {
          name: "ID",
          title: "ID"
        },
        {
          name: "User Type"
        },
        {
          name: "Start Time"
        },
        {
          name: "End Time"
        },
        {
          name: "Time Remain"
        },
        {
          name: "Reason"
        },
        "Delete"
      ],
      passedBlacklistFields: [
        {
          name: "No",
          title: "No."
        },
        {
          name: "Name",
          title: "Name"
        },
        {
          name: "ID",
          title: "ID"
        },
        "User Type",
        "Start Time",
        "End Time",
        "Time Remain",
        "Reason"
      ],
      tablecss: {
        tableClass:
          "table table-responsive table-striped table-bordered table-hover signed-users-list",
        titleClass: "title-class"
      },
      searchInputName: "",
      searchInputId: "",
      searchIsAdmin: false,
      searchResult: [],
      searchResultShow: false,
      paginationcss: {
        wrapperClass: "btn-group pull-right",
        icons: {
          prev: "fa fa-chevron-left",
          next: "fa fa-chevron-right"
        },
        linkClass: "btn btn-default",
        dropdownClass: "btn btn-default dropdown-toggle",
        pageClass: "dropdown-menu",
        disabledClass: "btn-disabled"
      },
      sortType: "5",
      currentSortedData: [],
      perPageInput: "10",
      passedBlacklistPerPageInput: "10",
      outFile: "",
      delBlacklistName: "",
      delBlacklistSchoolId: "",
      delBlacklistId: "",
      errorMessage: "",
      errorShow: false
    };
  },
  watch: {
    sortType (newVal, oldVal) {
      this.sortArray(newVal);
      this.onPaginationData(this.formatBlacklistArray.pagination);
    },
    perPageInput (newVal, oldVal) {
      this.perPageInput = newVal;
      // console.log('currentSortedData',this.currentSortedData);
      this.formatBlacklistArray = this.transformBlacklist(
        this.currentSortedData,
        true,
        1
      );
      this.onPaginationData(this.formatBlacklistArray.pagination);
    },
    passedBlacklistPerPageInput (newVal, oldVal) {
      this.passedBlacklistPerPageInput = newVal;
      this.formatPassedBlacklistArray = this.transformPassedBlacklist(
        this.passedBlacklistArray,
        true,
        1
      );
      this.onPassedBlacklistPaginationData(
        this.formatPassedBlacklistArray.pagination
      );
    }
  },
  mounted () {
    this.fetchBlacklists();
    this.fetchAllUsersData();
    this.outFile = document.createElement("a");
  },
  methods: {
    sortArray (type) {
      const that = this;
      let sortedArray = [];
      that.currentSortedData = [];
      switch (type) {
        case "0":
          sortedArray = that.blacklistArray.sort(that.compare("name", true));
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
        case "1":
          sortedArray = that.blacklistArray.sort(that.compare("name", false));
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
        case "2":
          sortedArray = that.blacklistArray.sort(that.compare("ldap_id", true));
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
        case "3":
          sortedArray = that.blacklistArray.sort(
            that.compare("ldap_id", false)
          );
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
        case "4":
          sortedArray = that.blacklistArray.sort(that.compare("id", true));
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
        case "5":
          sortedArray = that.blacklistArray.sort(that.compare("time", true));
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
        case "6":
          sortedArray = that.blacklistArray.sort(that.compare("time", false));
          that.currentSortedData = sortedArray;
          that.formatBlacklistArray = that.transformBlacklist(
            sortedArray,
            true,
            1
          );
          break;
      }
    },
    compare (property, positive) {
      switch (property) {
        case "id":
          return function (a, b) {
            let value1 = a.user.id;
            let value2 = b.user.id;
            if (value2 > value1) {
              return -1;
            } else if (value2 === value1) {
              return 0;
            } else {
              return 1;
            }
          };
        case "name":
          if (positive) {
            return function (a, b) {
              let value1 = a.user.name;
              let value2 = b.user.name;
              return value1.localeCompare(value2, "zh-Hans-CN");
            };
          } else {
            return function (a, b) {
              let value1 = a.user.name;
              let value2 = b.user.name;
              return value2.localeCompare(value1, "zh-Hans-CN");
            };
          }
        case "time":
          if (positive) {
            return function (a, b) {
              let value1 = a.end_date;
              let value2 = b.end_date;
              if (value2 < value1) {
                return -1;
              } else if (value2 === value1) {
                return 0;
              } else {
                return 1;
              }
            };
          } else {
            return function (a, b) {
              let value1 = a.end_date;
              let value2 = b.end_date;
              if (value2 < value1) {
                return 1;
              } else if (value2 === value1) {
                return 0;
              } else {
                return -1;
              }
            };
          }
        case "ldap_id":
          if (positive) {
            return function (a, b) {
              let value1 = a.user.ldap_id;
              let value2 = b.user.ldap_id;
              if (value2 > value1) {
                return -1;
              } else if (value2 === value1) {
                return 0;
              } else {
                return 1;
              }
            };
          } else {
            return function (a, b) {
              let value1 = a.user.ldap_id;
              let value2 = b.user.ldap_id;
              if (value2 > value1) {
                return 1;
              } else if (value2 === value1) {
                return 0;
              } else {
                return -1;
              }
            };
          }
      }
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onPassedBlacklistPaginationData (paginationData) {
      this.$refs.passedBlacklistPagination.setPaginationData(paginationData);
      this.$refs.passedBlacklistPaginationInfo.setPaginationData(
        paginationData
      );
    },
    transform (data) {
      const that = this;
      let transformed = {};
      transformed.data = [];
      for (var i = 0; i < data.length; i++) {
        transformed.data.push({
          No: data[i].id,
          Name: data[i].name,
          ID: data[i].ldap_id,
          "User Type": that.checkRoles(data[i].roles),
          "Add To Blacklist": `<button type="submit" class="btn btn-xs btn-danger"
                           data-toggle="modal">Add Blacklist</button>`
        });
      }
      return transformed;
    },
    transformBlacklist (data, pagination, currentPage) {
      const that = this;
      let transformed = {};
      transformed.data = [];
      let perPage = parseInt(that.perPageInput);
      let startIndex = (currentPage - 1) * perPage;
      let endIndex = currentPage * perPage;
      if (endIndex > data.length) {
        endIndex = data.length;
      }
      for (var i = startIndex; i < endIndex; i++) {
        let current = data[i];
        transformed.data.push({
          No: current.id,
          Name: current.user.name,
          ID: current.user.ldap_id,
          "User Type": that.checkRoles(current.user.roles),
          "Start Time": moment.unix(current.begin_date).format("YYYY-MM-DD"),
          "End Time": moment.unix(current.end_date).format("YYYY-MM-DD"),
          "Time Remain": moment.unix(current.end_date).fromNow(true),
          Reason: current.blacklist_note,
          Delete: `<button type="submit" class="btn btn-xs btn-danger"
                    data-toggle="modal" data-target="#delBlacklistModal">Delete</button>`
        });
      }
      if (pagination === true) {
        transformed.pagination = {
          total: data.length,
          per_page: perPage,
          current_page: currentPage,
          last_page: Math.ceil(data.length / perPage),
          from: 1,
          to: Math.ceil(data.length / perPage),
          prev: currentPage - 1,
          next: currentPage + 1
        };
      }
      console.log(transformed.pagination.current_page);
      return transformed;
    },
    transformPassedBlacklist (data, pagination, currentPage) {
      const that = this;
      let transformed = {};
      transformed.data = [];
      let perPage = parseInt(that.passedBlacklistPerPageInput);
      let startIndex = (currentPage - 1) * perPage;
      let endIndex = currentPage * perPage;
      if (endIndex > data.length) {
        endIndex = data.length;
      }
      for (var i = startIndex; i < endIndex; i++) {
        let current = data[i];
        transformed.data.push({
          No: current.id,
          Name: current.user.name,
          ID: current.user.ldap_id,
          "User Type": that.checkRoles(current.user.roles),
          "Start Time": moment.unix(current.begin_date).format("YYYY-MM-DD"),
          "End Time": moment.unix(current.end_date).format("YYYY-MM-DD"),
          "Time Remain": "Passed",
          Reason: current.blacklist_note
          /*Delete: `<button type="submit" class="btn btn-xs btn-danger"
                    data-toggle="modal" data-target="#delBlacklistModal">Delete</button>`*/
        });
      }
      if (pagination === true) {
        transformed.pagination = {
          total: data.length,
          per_page: perPage,
          current_page: currentPage,
          last_page: Math.ceil(data.length / perPage),
          from: 1,
          to: Math.ceil(data.length / perPage),
          prev: currentPage - 1,
          next: currentPage + 1
        };
      }
      // console.log(transformed.pagination.current_page);
      // console.log(transformed);
      return transformed;
    },
    onChangePage (page) {
      // console.log(page);
      if (page < 1 || page > this.formatBlacklistArray.pagination.last_page) {
        return;
      }
      this.formatBlacklistArray = this.transformBlacklist(
        this.currentSortedData,
        true,
        page
      );
      this.onPaginationData(this.formatBlacklistArray.pagination);
    },
    onPassedBlacklistChangePage (page) {
      // console.log(page);
      if (
        page < 1 ||
        page > this.formatPassedBlacklistArray.pagination.last_page
      ) {
        return;
      }
      this.formatPassedBlacklistArray = this.transformPassedBlacklist(
        this.passedBlacklistArray,
        true,
        page
      );
      this.onPassedBlacklistPaginationData(
        this.formatPassedBlacklistArray.pagination
      );
    },
    checkSearchInput () {
      if (this.searchInputName.trim() === "") {
        if (this.searchInputId.trim() === "") {
          if (!this.searchIsAdmin) {
            return 0; // All are empty
          } else {
            return 1; // Only type is filled
          }
        } else {
          if (!this.searchIsAdmin) {
            return 2; // Only Id is filled
          } else {
            return 3; // Id and Type are filled
          }
        }
      } else {
        if (this.searchInputId.trim() === "") {
          if (!this.searchIsAdmin) {
            return 4; // Only Name is filled
          } else {
            return 5; // Name and Type are filled
          }
        } else {
          if (!this.searchIsAdmin) {
            return 6; // ID and Name are filled
          } else {
            return 7; // All are filled
          }
        }
      }
    },
    checkRoles (value) {
      if (value.length !== 0) {
        return value[0] === "Admin" ? "Admin" : ""
      }
      return ""
    },
    searchReset () {
      this.searchInputName = "";
      this.searchInputId = "";
      this.searchIsAdmin = false;
      this.searchResult = [];
      this.searchResultShow = false;
    },
    searchSignedUser () {
      let targetArray = [];
      let searchInputNameRegExp = RegExp(this.searchInputName.toLowerCase());
      let searchInputIdRegExp = RegExp(this.searchInputId);
      switch (this.checkSearchInput()) {
        case 0:
          this.searchResult = this.usersInfo;
          break;
        case 1:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 2:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 3:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
              if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 4:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 5:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 6:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 7:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
                if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                  targetArray.push(this.usersInfo[i]);
                }
              }
            }
          }
          break;
      }
      if (targetArray.length === 0) {
        toastr.error("There is no match result!");
      } else {
        this.searchResult = this.transform(targetArray);
        this.searchResultShow = true;
      }
    },
    // TODO: 还缺少验证用户是否已入黑名单，输入是否正确及提交post请求后关闭modal
    /* searchUserId: function(key) {
      // eslint-disable-next-line
      var $this = this;
      // eslint-disable-next-line
      this.request
        .get("user/")
        .then(function(response) {
          // localStorage.setItem('userArray', response.data.users);
          // console.log(response);
          // console.log(response.data.users[0]);
          // eslint-disable-next-line
          $this.userArray = response.data.users;
        })
        .catch(error => {
          window.alert(error);
        });
      // eslint-disable-next-line
      var len = $this.userArray.length;
      // eslint-disable-next-line
      var i = 0;
      // eslint-disable-next-line
      for (i; i < len; i++) {
        // eslint-disable-next-line
        console.log($this.userArray[i].ldap_id);
        console.log(key);
        // eslint-disable-next-line
        console.log($this.userArray[i].ldap_id == key);
        // eslint-disable-next-line
        if ($this.userArray[i].ldap_id == key) {
          $this.addBlacklistId = $this.userArray[i].id;
        }
      }
    },*/
    onBlacklistCellClicked (data, field, event) {
      if (field.name === "Delete") {
        this.delBlacklistId = data["No"];
        this.delBlacklistName = data["Name"];
        this.delBlacklistSchoolId = data["ID"];
      }
    },
    onCellClicked (data, field, event) {
      const $ = window.jQuery;
      if (field.name === "Add To Blacklist") {
        if (this.checkUserBlacklistStatus(data.No)) {
          //TODO: prevent default modal show
          toastr.error("This user is in blacklist.");
        } else {
          this.addBlacklistId = data["No"];
          this.addBlacklistSchoolId = data["ID"];
          this.addBlacklistDate = Date();
          this.addBlacklistName = data["Name"];
          this.addBlacklistReason = "";
          this.errorShow = false
          this.errorMessage = ""
          $("#blacklistModal").modal("show");
        }
      }
    },
    checkUserBlacklistStatus: function (id) {
      //TODO: if blacklist backend has finished (now is null), change another checking rule
      let arr = this.blacklistArray;
      console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        if (parseInt(arr[i].id) === parseInt(id)) {
          return true;
        }
      }
      return false;
    },
    delUserBlacklistInfo () {
      // let delUserBlacklistUrl =
      $("#delBlacklistBtn").button("loading");
      const that = this;
      this.request
        .delete(`blacklist/${that.delBlacklistId}`, {})
        .then(function (response) {
          toastr.success(
            "You have successfully delete this user from blacklist!"
          );
          that.fetchBlacklists();
          that.errorMessage = "";
          that.errorShow = false;
          setTimeout(function () {
            $("#delBlacklistModal").modal("hide");
            console.log("successfully delete a person from blacklist");
            $("#delBlacklistBtn").button("reset");
          }, 500);
        })
        .catch(function (error) {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#delBlacklistBtn").button("reset");
        })
        .finally(() => {
          that.delBlacklistId = "";
          that.delBlacklistSchoolId = "";
          that.delBlacklistName = "";
        });
    },
    checkBlacklistValidation () {
      let reg = /[^!@#$%^&*~`:;"'{}[]<>,\.\|/;
      if (!this.addBlacklistName || reg.test(this.addBlacklistName)) {
        return "Please input a valid name!";
      }
      if (!this.addBlacklistSchoolId) {
        return "Please input a school id number!";
      }
      let nowDate = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
      let date = new Date(this.addBlacklistDate) / 1000;
      if (date < nowDate) {
        return "The start date should not be a passed day!";
      }
      if (!this.addBlacklistDate) {
        return "Please input valid a date!";
      }
      if (!this.addBlacklistDate) {
        return "Please input valid a date!";
      }
      if (!this.addBlacklistReason) {
        return "Please input a reason!";
      }
      return 0;
    },
    addUserToList: function () {
      // start loading
      $("#blacklistBtn").button("loading");
      console.log(this.addBlacklistDate);
      var that = this;
      that.errorShow = false;
      that.errorMessage = that.checkBlacklistValidation();
      if (that.errorMessage != 0) {
        setTimeout(function () {
          that.errorShow = true;
        }, 500);
        $("#blacklistBtn").button("reset");
        return;
      }
      this.postUserBlacklistStatusURL = "blacklist/add"; // TODO: ask backend to rename to user/<id>/blacklist
      // console.log(moment(that.addBlacklistDate).format('YYYY-MM-DD'));
      let date = new Date(that.addBlacklistDate);
      let dateStr = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
        .toISOString()
        .split("T")[0];
      this.request
        .post(that.postUserBlacklistStatusURL, {
          user_ldap_id: that.addBlacklistSchoolId,
          user_name: that.addBlacklistName,
          // begin_date: moment.unix(that.addBlacklistDate),
          //begin_date: moment(that.addBlacklistDate).format('YYYY-MM-DD'),
          // begin_date: s.toISOStringZoned(),
          begin_date: dateStr,
          blacklist_note: that.addBlacklistReason
        })
        .then(function (response) {
          that.fetchBlacklists();
          that.addBlacklistId = "";
          that.addBlacklistDate = Date();
          that.addBlacklistSchoolId = "";
          that.addBlacklistName = "";
          that.addBlacklistReason = "";
          that.errorMessage = "";
          that.errorShow = false;
          setTimeout(function () {
            $("#blacklistModal").modal("hide");
            console.log("successfully add a person to blacklist");
            // stop loading
            $("#blacklistBtn").button("reset");
          }, 500);
        })
        .catch(function (error) {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          // stop loading
          $("#blacklistBtn").button("reset");
        });
    },
    fetchBlacklists () {
      const that = this;

      window.request
        .get("blacklist/")
        .then(response => {
          if (response.data.blacklists) {
            const today = Date.now() / 1000;
            response.data.blacklists.forEach(blacklist => {
              blacklist.status = blacklist.end_date > today;
              if (blacklist.end_date > today) {
                that.blacklistArray.push(blacklist);
              } else {
                that.passedBlacklistArray.push(blacklist);
              }
            });
            // that.blacklistArray = response.data.blacklists;
          }
        })
        .finally(() => {
          // TEST Data
          /*that.blacklistArray.push({
              id: 2,
              user:{
                name: '李卓炫',
                ldap_id: '116010111',
                roles: [],
              },
              begin_date: 1538150400,
              end_date: 1539584945,
              blacklist_note: 'Test',
            },
            {
              id: 3,
              user:{
                name: '李淑英',
                ldap_id: '116010888',
                roles: [],
              },
              begin_date: 1538150400,
              end_date: 1538826580,
              blacklist_note: 'Test',
            },
            {
              id: 4,
              user:{
                name: '丁欣怡',
                ldap_id: '115010999',
                roles: [],
              },
              begin_date: 1538150400,
              end_date: 1538726580,
              blacklist_note: 'Test',
            },
            {
              id: 5,
              user:{
                name: '陈馨蕊',
                ldap_id: '116010000',
                roles: [],
              },
              begin_date: 1538150400,
              end_date: 1538726580,
              blacklist_note: 'Test',
            });*/
          that.currentSortedData = that.blacklistArray.sort(
            that.compare("time", true)
          );
          that.formatBlacklistArray = that.transformBlacklist(
            that.currentSortedData,
            true,
            1
          );
          that.onPaginationData(that.formatBlacklistArray.pagination);

          that.formatPassedBlacklistArray = that.transformPassedBlacklist(
            that.passedBlacklistArray,
            true,
            1
          );
          that.onPassedBlacklistPaginationData(
            that.formatPassedBlacklistArray.pagination
          );
          // console.log(that.formatPassedBlacklistArray);
          that.$emit("hideLoading");
        });
    },
    fetchAllUsersData () {
      const that = this;
      this.$emit("showLoading");
      if (this.user) {
        window.request
          .get(`user/`)
          .then(response => {
            that.usersInfo = response.data.users;
          })
          .catch(error => {
            window.alert(error);
            toastr.error(error.data.message);
          })
          .finally(() => {
            that.$emit("hideLoading");
          });
      }
    },
    downloadBlacklist () {
      //导出按钮
      const that = this;
      let tempData = [];
      let beginDate = "";
      let endDate = "";
      let timeRemain = "";
      let today = new Date();
      for (let k in that.blacklistArray) {
        if (that.blacklistArray[k].begin_date != "") {
          beginDate = new Date();
          beginDate.setTime(that.blacklistArray[k].begin_date * 1000);
          beginDate = beginDate.toLocaleDateString();
        }
        if (that.blacklistArray[k].end_date != "") {
          endDate = new Date();
          endDate.setTime(that.blacklistArray[k].end_date * 1000);
          endDate = endDate.toLocaleDateString();
        }
        //获取剩余时间
        //if (that.blacklistArray[k].begin_date != "" && that.blacklistArray[k].end_date != "") {
        //  let startTime = new Date();
        //  startTime.setTime(that.blacklistArray[k].begin_date);
        //  let endTime = new Date();
        //  endTime.setTime(that.blacklistArray[k].end_date);
        //  let t = endTime - startTime;
        //  console.log('begin date', startTime);
        //  console.log('end date', endTime);
        //  console.log('t', t);
        //  timeRemain = (t/(60*60*24)+1) + ' days';
        //}
        tempData.push({
          ID: that.blacklistArray[k].id,
          "Name": that.blacklistArray[k].user.name,
          "Student ID": that.blacklistArray[k].user.ldap_id,
          "Student Email": that.blacklistArray[k].user.email,
          "Begin Date": beginDate,
          "End Date": endDate,
          //time_remain: timeRemain,
          reason: that.blacklistArray[k].blacklist_note
        });
      }

      this.downloadExl(tempData, "BlackList_" + today.toLocaleDateString());
    },
    downloadExl (data, downName) {
      var workbook = XLSX.utils.book_new();

      var ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, ws, "Results");
      XLSX.writeFile(workbook, downName + '.xlsx', { type: 'file' });
    },
    s2ab (s) {
      // 字符串转字符流
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },
    getTimeRemain (beginDate, endDate) {
      let t = Date.parse(endtime) - Date.parse(new Date());
      let days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        total: t,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      };
    }
  }
};
</script>

<style>
</style>

<style scoped>
@media (max-width: 426px) {
  .mobile-hide {
    display: none;
  }
}
@media (min-width: 426px) {
  .mobile-show {
    display: none;
  }
}

#add_blacklist {
  padding: 2% 1% 0 10%;
}

#add_blacklist-mobile {
  padding: 20px 1% 0 0;
}
</style>
